// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/css/style.css'
import 'lib-flexible/flexible'

Vue.config.productionTip = false
Vue.use(Vant)
import utils from './pages/utils/public.js'
  Vue.prototype.utils = utils
  import axios from 'axios'
import api from'./api/index.js'
import VueCanvasPoster from 'vue-canvas-poster'
Vue.use(VueCanvasPoster)
Vue.prototype.api = api


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js